import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Feature } from '../model/rootObjectFeature';

@Injectable({
    providedIn: 'root'
})
export class FeatureEntityService extends EntityCollectionServiceBase<Feature> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('Feature', serviceElementsFactory);
    }
}
